import { ApolloClient, HttpLink, InMemoryCache } from "apollo-boost";
import { ApolloLink } from "apollo-link";
import buildAxiosFetch from "../../axios-fetch";
import graphFetch from "../graph/fetch";
import typeDefs from "./schema";
import errorLink from "./utils/errorLink";
var httpLink = new HttpLink({
    fetch: buildAxiosFetch(graphFetch)
});
var formatCacheKey = function (type, id) { return type + "@" + id; };
/**
 * @description caching SlimDeals by their uuid will cause duplicates to be stored if there are
 * multiple locations for the same deal. Using the deal's location uuid ensures each deal is unique.
 */
var formatSlimDealCacheKey = function (locationId) {
    return "SlimDeal@" + locationId;
};
export var cache = new InMemoryCache({
    dataIdFromObject: function (object) {
        if (object.__typename === "SlimDeal") {
            return formatSlimDealCacheKey(object.location.uuid);
        }
        return !object.uuid && !object.id ? null : formatCacheKey(object.__typename, object.uuid || object.id);
    },
    cacheRedirects: {
        Query: {
            poll: function (_, args, _a) {
                var getCacheKey = _a.getCacheKey;
                return getCacheKey({
                    uuid: args.id,
                    __typename: "Poll"
                });
            },
            recognition: function (_, args, _a) {
                var getCacheKey = _a.getCacheKey;
                return getCacheKey({
                    uuid: args.id,
                    __typename: "Recognition"
                });
            }
        }
    }
});
// omit typename on update https://github.com/apollographql/apollo-client/issues/1564
var omitTypename = function (key, value) { return (key === "__typename" ? undefined : value); };
var apolloLink = new ApolloLink(function (operation, forward) {
    if (operation.variables) {
        operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
    }
    return forward(operation);
});
var link = apolloLink.concat(errorLink).concat(httpLink);
var client = new ApolloClient({
    link: link,
    cache: cache,
    typeDefs: typeDefs
});
export default client;
